// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var FileUpload = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M9.586 0a1 1 0 0 1 .608.206l.099.087L14 4a1 1 0 0 1-1 1H9.5a.5.5 0 0 1-.5-.5V1H3a1 1 0 0 0-.993.883L2 2v12a1 1 0 0 0 .883.993L3 15h9a1 1 0 0 0 .993-.883L13 14V7.5a.5.5 0 0 1 .992-.09L14 7.5V14a2 2 0 0 1-1.851 1.995L12 16H3a2 2 0 0 1-1.995-1.851L1 14V2C1 .946 1.816.082 2.851.005L3 0zM10 1.415V4h2.585z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.5 6h.012l.031.002.035.004.012.002.016.003.05.014.018.006.013.005.02.009.024.012a.4.4 0 0 1 .07.044.3.3 0 0 1 .039.033l.012.012 2.5 2.5a.5.5 0 0 1-.707.707L7.999 7.706v3.793a.5.5 0 0 1-1 0V7.705L5.353 9.353a.5.5 0 0 1-.707-.707l2.512-2.512.039-.033-.051.045a.5.5 0 0 1 .122-.089l.024-.012.02-.009.013-.005.018-.006.05-.014.016-.003.012-.002.035-.004L7.487 6h.011z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(FileUpload);
export default ForwardRef;
